/* Al Ubaid Motors Toyota Sienta MSRP update data. Upload this file to Shopify Assets as aum-toyota-sienta-msrp.js */
(function(){
  const AUM_ROWS = window.AUM_ROWS = window.AUM_ROWS || [];

  function aumSlug(value){
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]+/g,"-").replace(/^-+|-+$/g,"").replace(/-+/g,"-");
  }

  function aumIsToyotaSientaRow(row){
    const text = [
      row && row.make,
      row && row.model,
      row && row.name,
      row && row.variant,
      row && row.variantLabel,
      row && row.method,
      row && row.status,
      row && row.row
    ].join(" ").toUpperCase();
    return text.indexOf("TOYOTA") !== -1 && text.indexOf("SIENTA") !== -1;
  }

  // Replace old/incomplete Toyota Sienta rows with the latest user-provided MSRP rows.
  const keptRows = AUM_ROWS.filter(function(row){ return !aumIsToyotaSientaRow(row); });
  AUM_ROWS.length = 0;
  keptRows.forEach(function(row){ AUM_ROWS.push(row); });

  const AUM_TOYOTA_SIENTA_PACKED = `08/2025|X|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2025|2077900|1270|4260mm × 1695mm × 1695mm
08/2025|X|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2025|2117500|1290|4260mm × 1695mm × 1695mm
08/2025|G|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2025|2424400|1280|4260mm × 1695mm × 1695mm
08/2025|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2025|2439800|1330|4260mm × 1695mm × 1695mm
08/2025|G|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2025|2464000|1300|4260mm × 1695mm × 1695mm
08/2025|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2025|2479400|1350|4260mm × 1695mm × 1695mm
08/2025|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2025|2637800|1380|4260mm × 1695mm × 1715mm
08/2025|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2025|2677400|1400|4260mm × 1695mm × 1715mm
08/2025|Z|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2025|2733500|1280|4260mm × 1695mm × 1695mm
08/2025|Z|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2025|2773100|1300|4260mm × 1695mm × 1695mm
08/2025|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2025|2774200|1340|4260mm × 1695mm × 1695mm
08/2025|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2025|2814900|1360|4260mm × 1695mm × 1695mm
08/2025|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2025|2972200|1390|4260mm × 1695mm × 1715mm
08/2025|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2025|3012900|1410|4260mm × 1695mm × 1715mm
08/2025|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2025|3083300|1350|4260mm × 1695mm × 1695mm
08/2025|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2025|3124000|1370|4260mm × 1695mm × 1695mm
08/2025|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2025|3281300|1400|4260mm × 1695mm × 1715mm
08/2025|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2025|3322000|1420|4260mm × 1695mm × 1715mm
05/2024|X|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2024|1995200|1270|4260mm × 1695mm × 1695mm
05/2024|X|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2024|2035200|1290|4260mm × 1695mm × 1695mm
05/2024|G|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2024|2337500|1280|4260mm × 1695mm × 1695mm
05/2024|G|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2024|2377500|1300|4260mm × 1695mm × 1695mm
05/2024|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2024|2390000|1330|4260mm × 1695mm × 1695mm
05/2024|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2024|2430000|1350|4260mm × 1695mm × 1695mm
05/2024|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2024|2588000|1380|4260mm × 1695mm × 1715mm
05/2024|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2024|2628000|1400|4260mm × 1695mm × 1715mm
05/2024|Z|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2024|2646600|1280|4260mm × 1695mm × 1695mm
05/2024|Z|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2024|2686600|1300|4260mm × 1695mm × 1695mm
05/2024|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2024|2687500|1340|4260mm × 1695mm × 1695mm
05/2024|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2024|2727500|1360|4260mm × 1695mm × 1695mm
05/2024|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2024|2885500|1390|4260mm × 1695mm × 1715mm
05/2024|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2024|2925500|1410|4260mm × 1695mm × 1715mm
05/2024|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2024|2996600|1350|4260mm × 1695mm × 1695mm
05/2024|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2024|3036600|1370|4260mm × 1695mm × 1695mm
05/2024|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2024|3194600|1400|4260mm × 1695mm × 1715mm
05/2024|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2024|3234600|1420|4260mm × 1695mm × 1715mm
08/2022|X|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2022|1950000|1270|4260mm × 1695mm × 1695mm
08/2022|X|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2022|1990000|1290|4260mm × 1695mm × 1695mm
08/2022|G|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2022|2300000|1280|4260mm × 1695mm × 1695mm
08/2022|G|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2022|2340000|1300|4260mm × 1695mm × 1695mm
08/2022|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2022|2380000|1330|4260mm × 1695mm × 1695mm
08/2022|HYBRID X|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2022|2420000|1350|4260mm × 1695mm × 1695mm
08/2022|Z|0|5BA-MXPC10G|MXPC10|1490|5|5|MPV|PETROL|FF|2022|2520000|1280|4260mm × 1695mm × 1695mm
08/2022|Z|0|5BA-MXPC10G|MXPC10|1490|5|7|MPV|PETROL|FF|2022|2560000|1300|4260mm × 1695mm × 1695mm
08/2022|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2022|2578000|1380|4260mm × 1695mm × 1715mm
08/2022|HYBRID X|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2022|2618000|1400|4260mm × 1695mm × 1715mm
08/2022|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2022|2650000|1340|4260mm × 1695mm × 1695mm
08/2022|HYBRID G|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2022|2690000|1360|4260mm × 1695mm × 1695mm
08/2022|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2022|2848000|1390|4260mm × 1695mm × 1715mm
08/2022|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|5|MPV|HYBRID|FF|2022|2870000|1350|4260mm × 1695mm × 1695mm
08/2022|HYBRID G|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2022|2888000|1410|4260mm × 1695mm × 1715mm
08/2022|HYBRID Z|0|6AA-MXPL10G|MXPL10|1490|5|7|MPV|HYBRID|FF|2022|2910000|1370|4260mm × 1695mm × 1695mm
08/2022|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|5|MPV|HYBRID|4WD|2022|3068000|1400|4260mm × 1695mm × 1715mm
08/2022|HYBRID Z|0|6AA-MXPL15G|MXPL15|1490|5|7|MPV|HYBRID|4WD|2022|3108000|1420|4260mm × 1695mm × 1715mm
06/2021|FUNBASE X|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2021|1818500|1320|4260mm × 1695mm × 1675mm
06/2021|X|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2021|1859200|1320|4260mm × 1695mm × 1675mm
06/2021|X|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2021|2003300|1380|4260mm × 1695mm × 1695mm
06/2021|FUNBASE G|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2021|2066000|1320|4260mm × 1695mm × 1675mm
06/2021|G|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2021|2107000|1320|4260mm × 1695mm × 1675mm
06/2021|FUNBASE G SAFETY EDITION II|1|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2021|2110000|1320|4260mm × 1695mm × 1675mm
06/2021|X|0|5BA-NSP172G|NSP172|1496|5|5|MPV|PETROL|FF|2021|2138000|1360|4260mm × 1695mm × 1675mm
06/2021|G SAFETY EDITION II|1|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2021|2151000|1320|4260mm × 1695mm × 1675mm
06/2021|FUNBASE G CUERO|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2021|2173000|1320|4260mm × 1695mm × 1675mm
06/2021|G CUERO|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2021|2214000|1320|4260mm × 1695mm × 1675mm
06/2021|HYBRID FUNBASE X|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2021|2236500|1380|4260mm × 1695mm × 1675mm
06/2021|G|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2021|2251000|1380|4260mm × 1695mm × 1695mm
06/2021|HYBRID X|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2021|2277200|1380|4260mm × 1695mm × 1675mm
06/2021|G SAFETY EDITION II|1|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2021|2295000|1380|4260mm × 1695mm × 1695mm
06/2021|G CUERO|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2021|2358000|1380|4260mm × 1695mm × 1695mm
06/2021|G|0|5BA-NSP172G|NSP172|1496|5|5|MPV|PETROL|FF|2021|2361000|1360|4260mm × 1695mm × 1675mm
06/2021|HYBRID FUNBASE G|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2021|2432000|1380|4260mm × 1695mm × 1675mm
06/2021|HYBRID G|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2021|2473000|1380|4260mm × 1695mm × 1675mm
06/2021|HYBRID FUNBASE G SAFETY EDITION II|1|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2021|2476000|1380|4260mm × 1695mm × 1675mm
06/2021|HYBRID G SAFETY EDITION II|1|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2021|2517000|1380|4260mm × 1695mm × 1675mm
06/2021|HYBRID FUNBASE G CUERO|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2021|2539000|1380|4260mm × 1695mm × 1675mm
06/2021|HYBRID G CUERO|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2021|2580000|1380|4260mm × 1695mm × 1675mm
06/2020|FUNBASE X|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|1809500|1320|4260mm × 1695mm × 1675mm
06/2020|X|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|1850200|1320|4260mm × 1695mm × 1675mm
06/2020|X|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|1994300|1380|4260mm × 1695mm × 1695mm
06/2020|FUNBASE G|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|2057000|1320|4260mm × 1695mm × 1675mm
06/2020|FUNBASE G GLAMPER|1|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|2068000|1320|4260mm × 1695mm × 1675mm
06/2020|G|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|2098000|1320|4260mm × 1695mm × 1675mm
06/2020|G GLAMPER|1|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|2109000|1320|4260mm × 1695mm × 1675mm
06/2020|X|0|5BA-NSP172G|NSP172|1496|5|5|MPV|PETROL|FF|2020|2130000|1360|4260mm × 1695mm × 1675mm
06/2020|FUNBASE G SAFETY EDITION|1|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|2155000|1320|4260mm × 1695mm × 1675mm
06/2020|FUNBASE G CUERO|0|5BA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|2173000|1320|4260mm × 1695mm × 1675mm
06/2020|G SAFETY EDITION|1|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|2196000|1320|4260mm × 1695mm × 1675mm
06/2020|G CUERO|0|5BA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|2214000|1320|4260mm × 1695mm × 1675mm
06/2020|HYBRID FUNBASE X|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2227500|1380|4260mm × 1695mm × 1675mm
06/2020|G|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|2242000|1380|4260mm × 1695mm × 1695mm
06/2020|G GLAMPER|1|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|2253000|1380|4260mm × 1695mm × 1695mm
06/2020|HYBRID X|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2268200|1380|4260mm × 1695mm × 1675mm
06/2020|G SAFETY EDITION|1|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|2340000|1380|4260mm × 1695mm × 1695mm
06/2020|G|0|5BA-NSP172G|NSP172|1496|5|5|MPV|PETROL|FF|2020|2353000|1360|4260mm × 1695mm × 1675mm
06/2020|G CUERO|0|3BA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|2358000|1380|4260mm × 1695mm × 1695mm
06/2020|HYBRID FUNBASE G|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2423000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID FUNBASE G GLAMPER|1|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2434000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID G|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2464000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID G GLAMPER|1|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2475000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID FUNBASE G SAFETY EDITION|1|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2521000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID FUNBASE G CUERO|0|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2539000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID G SAFETY EDITION|1|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2562000|1380|4260mm × 1695mm × 1675mm
06/2020|HYBRID G CUERO|0|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2580000|1380|4260mm × 1695mm × 1675mm
01/2020|FUNBASE G SAFETY EDITION|1|DBA-NSP170G|NSP170|1496|5|5|MPV|PETROL|FF|2020|2115300|1320|4260mm × 1695mm × 1675mm
01/2020|G SAFETY EDITION|1|DBA-NSP170G|NSP170|1496|5|7|MPV|PETROL|FF|2020|2156000|1320|4260mm × 1695mm × 1675mm
01/2020|G SAFETY EDITION|1|DBA-NCP175G|NCP175|1496|5|7|MPV|PETROL|4WD|2020|2300100|1380|4260mm × 1695mm × 1695mm
01/2020|HYBRID FUNBASE G SAFETY EDITION|1|6AA-NHP170G|NHP170|1496|5|5|MPV|HYBRID|FF|2020|2481600|1380|4260mm × 1695mm × 1675mm
01/2020|HYBRID G SAFETY EDITION|1|6AA-NHP170G|NHP170|1496|5|7|MPV|HYBRID|FF|2020|2522300|1380|4260mm × 1695mm × 1675mm`;

  AUM_TOYOTA_SIENTA_PACKED.trim().split(/\n+/).forEach(function(line){
    const p = line.split("|");
    const sale = p[0] || "";
    const variantRaw = p[1] || "";
    const limited = p[2] === "1";
    const fullCode = p[3] || "";
    const chassis = p[4] || fullCode;
    const cc = Number(p[5] || 0);
    const doors = Number(p[6] || 0);
    const seats = Number(p[7] || 0);
    const type = p[8] || "MPV";
    const fuel = p[9] || "PETROL";
    const drive = p[10] || "";
    const year = Number(p[11] || 0);
    const msrp = Number(p[12] || 0);
    const weightKg = Number(p[13] || 0);
    const dimensions = p[14] || "";
    const rowId = "TOYOTA-SIENTA-" + aumSlug(chassis) + "-" + aumSlug(variantRaw) + "-" + aumSlug(sale) + "-" + seats + "SEAT-" + msrp;
    const variantLabel = variantRaw + (limited ? " · Limited Model" : "") + (seats ? " · " + seats + " Seats" : "") + " · " + fullCode + " · Sale " + sale;

    const row = {
      row: rowId,
      chassis: chassis,
      make: "TOYOTA",
      model: "SIENTA",
      name: "TOYOTA SIENTA",
      variant: variantRaw,
      variantLabel: variantLabel,
      type: type,
      fuel: fuel,
      year: year,
      cc: cc,
      doors: doors,
      seats: seats,
      drive: drive,
      cur: "JPY",
      msrp: msrp,
      method: "TOYOTA SIENTA MSRP",
      sourceUrl: "https://www.goo-net-exchange.com/catalog/TOYOTA__SIENTA/",
      status: "Manual MSRP · TOYOTA SIENTA · " + fullCode + " · Sale " + sale + " · User provided"
    };
    if(weightKg) row.weightKg = weightKg;
    if(dimensions) row.dimensions = dimensions;
    AUM_ROWS.push(row);
  });
})();
